var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFavourite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_344_1172)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.00001 16.561C8.60369 16.1841 8.13312 15.726 7.61293 15.2195C7.198 14.8152 6.7522 14.3813 6.28974 13.9356L6.28973 13.9356C3.72608 11.4647 2.9432 10.6482 2.09512 9.42191L2.09512 9.4219C1.14362 8.0461 0.558286 7.17941 0.507104 5.88698L0.50716 5.88698L0.506751 5.87949C0.444274 4.73586 0.817289 3.61089 1.55102 2.73039C2.16946 2.0064 3.01248 1.50937 3.94624 1.31836C4.85757 1.15558 5.79714 1.28589 6.62956 1.69056L6.62952 1.69064L6.63816 1.69464C7.40747 2.05068 8.0822 2.58231 8.60796 3.24657L9.00005 3.74195L9.3921 3.24654C9.91775 2.5823 10.5925 2.05069 11.3618 1.69464L11.3619 1.69473L11.3705 1.69051C12.2029 1.28565 13.1424 1.15535 14.0537 1.31835C14.9875 1.50936 15.8306 2.00639 16.4489 2.73037C17.1827 3.61087 17.5557 4.73585 17.4933 5.8795L17.4932 5.8795L17.4929 5.88697C17.4417 7.1794 16.8564 8.0461 15.9049 9.4219C15.0568 10.6482 14.2739 11.4648 11.7102 13.9356L11.7102 13.9356C11.2478 14.3813 10.8021 14.8152 10.3871 15.2195L9.00001 16.561ZM9.00001 16.561C9.39623 16.1841 9.86677 15.7261 10.387 15.2196L9.00001 16.561Z",
    stroke: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_344_1172"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavourite);
export default __webpack_public_path__ + "static/media/favourite.88858297a5c9a34ea28f63e5730a6df2.svg";
export { ForwardRef as ReactComponent };